import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import am from './locales/am.json';
import ti from './locales/ti.json';
import om from './locales/om.json';

// Mirrors SUPPORTED_LANGUAGES in qerchabackend/utils/languages.js
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'am', label: 'አማርኛ' },
  { code: 'ti', label: 'ትግርኛ' },
  { code: 'om', label: 'Afaan Oromoo' },
];
const CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

// Guest choice is kept in localStorage; logout does not clear it
const storedLanguage = () => {
  const stored = localStorage.getItem('lang');
  return CODES.includes(stored) ? stored : 'en';
};

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, am: { translation: am }, ti: { translation: ti }, om: { translation: om } },
  lng: storedLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});
document.documentElement.lang = i18n.language;

// Saves the choice, switches the UI at once, and updates the document language (used for the Ethiopic font)
export function setLanguage(code) {
  if (!CODES.includes(code)) return;
  localStorage.setItem('lang', code);
  document.documentElement.lang = code;
  return i18n.changeLanguage(code);
}

export default i18n;
